import {GET_FCM_HISTORY_ERROR, GET_FCM_HISTORY_START, GET_FCM_HISTORY_SUCCESS} from "../../types";

export default function fcm_history(state, action) {
  switch (action.type) {
    case GET_FCM_HISTORY_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_FCM_HISTORY_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_FCM_HISTORY_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return {...state};
  }
}
